import { calculateHexSizeBasedOnWidth } from './calculate-hex-size-based-on-width.js';
import type { ShapeSizes } from '../../../types/rendering.js';

export const getHexagonSizes = (width: number): ShapeSizes => {
  const { hexSize, height, hexRadius } = calculateHexSizeBasedOnWidth(width);

  return {
    height,
    halfHeight: hexSize,
    halfWidth: hexRadius,
  };
};
